import { render, staticRenderFns } from "./lahi-discount.vue?vue&type=template&id=298e639b&scoped=true&lang=pug"
import script from "./lahi-discount.vue?vue&type=script&lang=js"
export * from "./lahi-discount.vue?vue&type=script&lang=js"
import style0 from "./lahi-discount.vue?vue&type=style&index=0&id=298e639b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e639b",
  null
  
)

export default component.exports